const firebaseConfig = {
    apiKey: "AIzaSyAXXfkdZkK6ynOvEWOQzg5_OupOWSvpn70",
    authDomain: "unihealtth.firebaseapp.com",
    projectId: "unihealtth",
    storageBucket: "unihealtth.appspot.com",
    messagingSenderId: "150190225276",
    appId: "1:150190225276:web:386729713b34c4039756f9"
};

export default firebaseConfig;